/**
 * 将法院案号中的半角括号年份 (年份) 转换为全角括号 （年份）
 * @param {string} caseNumber - 原始案号字符串
 * @returns {string} 转换后的案号字符串
 * @throws {TypeError} 输入非字符串类型时抛出错误
 */
export function convertToFullwidthBrackets(caseNumber) {
  // 兼容空值/undefined：避免模板中值未加载时报错
  if (!caseNumber || typeof caseNumber !== "string") {
    return caseNumber || ""; // 空值返回空字符串，非字符串原样返回
  }

  // 正则匹配半角括号+4位年份，全局替换
  const pattern = /\((\d{4})\)/g;
  return caseNumber.replace(pattern, (_, year) => `（${year}）`);
}